export const INDEX = "LUCKY_SPIN_INDEX";
// export const PRIZE_GROUP = "LUCKY_SPIN_PRIZE_GROUP";
export const STORE = "LUCKY_SPIN_STORE";